<div class="header">
  <!-- Router link here is default ["/"] -->
  <spb-logo routerLink="dokument"></spb-logo>
  <div [style.flex-grow]="1"></div>
  <div style="padding-right: 4px;">
    <spb-toggle-button/>
  </div>
</div>
